/**
 * RFC-4180-style CSV parser.
 *
 * - Strips a leading UTF-8 BOM.
 * - Normalizes CRLF and lone CR to LF.
 * - Handles quoted fields containing commas, newlines, and escaped quotes (`""`).
 * - Drops entirely-empty rows. Preserves rows where some cells are empty.
 */
export function parseCsv(text: string): string[][] {
  if (text.length === 0) return [];

  // Strip BOM
  if (text.charCodeAt(0) === 0xfeff) {
    text = text.slice(1);
  }

  // Normalize line endings
  text = text.replace(/\r\n?/g, '\n');

  const rows: string[][] = [];
  let row: string[] = [];
  let cell = '';
  let inQuotes = false;

  for (let i = 0; i < text.length; i++) {
    const ch = text[i];

    if (inQuotes) {
      if (ch === '"') {
        if (text[i + 1] === '"') {
          cell += '"';
          i++;
        } else {
          inQuotes = false;
        }
      } else {
        cell += ch;
      }
    } else {
      if (ch === '"') {
        inQuotes = true;
      } else if (ch === ',') {
        row.push(cell);
        cell = '';
      } else if (ch === '\n') {
        row.push(cell);
        cell = '';
        if (row.some(c => c.length > 0)) rows.push(row);
        row = [];
      } else {
        cell += ch;
      }
    }
  }

  // Final cell / row
  row.push(cell);
  if (row.some(c => c.length > 0)) rows.push(row);

  return rows;
}
